module.exports = "<li  uib-dropdown on-toggle=\"vm.toggled(open)\">\n  <a href=\"\" class=\"dropdown-toggle\" uib-dropdown-toggle>\n    {{vm.languageLabelInstant}}<span class=\"st-icon-chevron-down  st-icon-chevron-down-sm-button\"></span>\n  </a>\n  <ul class=\"dropdown-menu\" uib-dropdown-menu aria-labelledby=\"simple-dropdown\">\n      <li ng-repeat=\"lang in vm.languages\">\n          <a href ng-click=\"vm.fetchLanguage(lang)\"> {{lang | translate}} </a>\n      </li>\n  </ul>\n</li>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/languageSelector/languageSelector.html
// module id = 15
// module chunks = 0